import { initializeApp } from "firebase/app";
import { getAuth, browserSessionPersistence, setPersistence, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyA-qSXqeESyOWZAJ3nTIEgc5c1o95y0gec",
  authDomain: "chainedllm.firebaseapp.com", // Make sure this is correct
  projectId: "chainedllm",
  storageBucket: "chainedllm.appspot.com",
  messagingSenderId: "525896752369",
  appId: "1:525896752369:web:81b27167c04ea423221d50",
  measurementId: "G-7W9MJS69XE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Set persistence
setPersistence(auth, browserSessionPersistence)
  .catch((error) => {
    console.error("Error setting auth persistence:", error);
  });

// Create an instance of the Google auth provider
const provider = new GoogleAuthProvider();
// Enable any additional scopes if needed
// provider.addScope('https://www.googleapis.com/auth/contacts.readonly');

// Function to handle sign-in
const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    // Handle successful sign-in
    // console.log("Sign-in successful:", result.user);
    return result;
  } catch (error) {
    // Log detailed error information
    // console.error("Sign-in error:", error);
    // console.error("Error code:", error.code);
    // console.error("Error message:", error.message);
    
    // Handle specific error codes
    if (error.code === 'auth/popup-blocked') {
      // alert("Please allow popups for this website to sign in with Google.");
    } else if (error.code === 'auth/cancelled-popup-request') {
      // console.log("Popup was closed by the user");
    } else if (error.code === 'auth/unauthorized-domain') {
      // console.error("This domain is not authorized for OAuth operations. Add it in Firebase Console > Auth > Sign-in methods > Authorized domains");
    }
    
    throw error;
  }
};

export { auth, signInWithGoogle };